<template>
  <div class="pic_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font" @click="goBack()">{{ titleName }}</span>
      </header>
      <div class="title_line"></div>
      <body>
        <div v-if="isShowList && schoInfo.infoList.length">
          <div class="body_two">
            <div
              v-for="(item, index) in schoInfo.infoList"
              :key="index"
              class="body_one t-h"
              @click="checkItem(item)"
            >
              <div class="book_bg">
                <el-image :src="item.atFmimg" class="book_img_bg">
                  <div slot="error">
                    <el-image :src="defaultImg"> </el-image>
                  </div>
                </el-image>
                <div style="padding-right: 16px">
                  <p>文献类型:{{ item.atTypeName }}</p>
                  <p>{{ item.atTitle }}</p>
                  <p>{{ item.atDigest }}</p>
                </div>
              </div>
              <div class="line_two"></div>
            </div>
          </div>
          <div style="text-align: center; margin-top: 8px">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pageParams.pageSize"
              layout="prev, pager, next"
              :total="schoInfo.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else>
          <div style="font-size:18px;margin:20px 0;text-indent:44px;">敬请期待...</div>
        </div>
        <div class="ql-editor" v-show="isShowContent" v-html="htmlInfo"></div>
      </body>
    </div>
  </div>
</template>

<script>
import { getaAcalitList, setBrowerecord } from "@/network/api";
export default {
  data() {
    return {
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/pageico_5.png"),
      isShowContent: false,
      isShowList: true,
      htmlInfo: "",
      titleName: "学术文献",
      schoInfo: {
        infoList: [],
        total: 0,
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  watch: {
    $route(to) {
      if (to.name === "Scholary") {
        this.initData();
      }
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    checkItem(item) {
      setBrowerecord('acalit', item.id)
      this.htmlInfo = item.atContent;
      this.isShowContent = true;
      this.isShowList = false;
      this.titleName = "学术文献 | " + item.atTitle + " |【返回】";
    },
    goBack() {
      this.isShowContent = false;
      this.isShowList = true;
      this.titleName = "学术文献";
    },
    initData: function () {
      const params = this.$route.query.p;
      this.pageParams.atType = params;
      getaAcalitList(this.pageParams).then((res) => {
        this.schoInfo.infoList = res.rows;
        this.schoInfo.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.initData();
    },
  },
};
</script>


<style scoped>
.pic_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
}
p {
  text-align: left;
  text-indent: 24px;
  font-size: 16px;
  color: #787878;
  line-height: 24px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 6px;
}
.book_bg {
  display: flex;
  padding-bottom: 12px;
  margin-top: 12px;
}
.book_img_bg {
  width: 165px;
  height: 237px;
  flex-shrink: 0;
  margin-right: 12px;
}
.body_one {
  flex-basis: 50%;
}
.body_two {
  display: flex;
  flex-wrap: wrap;
}
.t-h:hover {
  color: #397b3e;
  cursor: pointer;
}
.t-h:hover p {
  color: #397b3e;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ScholarlyLiterature.vue